import styled, { CSSObject } from 'styled-components';

const BORDER_WIDTH = 2;

interface MenuStyledProps {
  sx?: CSSObject;
}

const MenuStyled = styled.div<MenuStyledProps>(({ theme, sx }) => ({
  border: `${BORDER_WIDTH}px solid ${theme.color.wfBlack}`,
  background: theme.color.wfWhite,
  boxSizing: 'border-box',
  position: 'absolute',
  minWidth: 270,
  zIndex: 99999,
  ...sx,
}));

export { MenuStyled };
